import { render, staticRenderFns } from "./DetailTitipJual.vue?vue&type=template&id=21ff654a&"
import script from "./DetailTitipJual.vue?vue&type=script&lang=js&"
export * from "./DetailTitipJual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports